// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Button, { ButtonPresentationProps } from "@ces/MobiusOverrides/Button/Button";
import { mergeWithCss } from "@ces/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { shallowEqual } from "react-redux";

export interface AddressLocationStyles {
    wrapper?: InjectableCss;
    headerText?: TypographyPresentationProps;
    changeLink?: ButtonPresentationProps;
}

export const addressLocationsStyles: AddressLocationStyles = {};

const AddressLocations = ({ expandedStyles }: { expandedStyles: AddressLocationStyles }) => {
    const styles = mergeWithCss(addressLocationsStyles, expandedStyles);
    const history = useHistory();
    const locationFinder = useAppSelector(state => getPageLinkByPageType(state, "LocationFinderPage"), shallowEqual);
    const handleChangeLocationClick = () => {
        history.push(locationFinder?.url || "/locationFinder");
    };

    return (
        <>
            <StyledWrapper
                id="AddressLocationStyles"
                role="region"
                aria-live="polite"
                data-test-selector="changeCustomer_location"
                {...styles.wrapper}
            >
                <Button
                    onClick={handleChangeLocationClick}
                    data-test-selector="changeCustomer_findLocation"
                    {...styles.changeLink}
                >
                    {translate("Locations")}
                </Button>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: AddressLocations,
    definition: {
        group: "Header",
        icon: "store",
    },
};

export default widgetModule;
